<template>
  <div class="ActivityLog">
    <v-row class="header d-flex">
      <v-col class="col-12 col-sm-9 text-sm-left text-center">
        <div class="title">{{ $t('crm.activityLog.title') }}</div>
        <div class="subtitle">{{ $t('crm.activityLog.subtitle') }}</div>
      </v-col>
    </v-row>
    <v-divider class="header-divider mt-8" />
    <div v-if="paginationLength > 0">
      <LogItem
        v-for="item in logs"
        :key="item.id"
        :element="item"
      />
      <v-pagination
        v-model="page"
        color="#009EE0"
        :length="paginationLength"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
      />
      <div class="custom-footer text-left pa-4">
        <span class="footer-length"> {{ totalLogs }}</span>
        <span> {{ $t('crm.activityLog.events') }}</span>
      </div>
    </div>
    <div
      v-else
      class="d-flex justify-center caption"
    >
      {{ $t('common.no-data') }}
    </div>
  </div>
</template>

<script>
  import CommonMixin from '@/mixins/store/CommonMixin'
  import LogItem from '@/pages/CRM/CustomerDetails/components/LogItem'
  import ApiService from '@/services/ApiService'
  import { sortBy, chunk } from '@/utils/common.utils'

  export default {
    components: {
      LogItem,
    },
    mixins: [CommonMixin,],
    data() {
      return {
        page: 1,
        perPage: 10,
        paginationLength: 4,
        totalLogs: 0,
        logs: [],
      }
    },
    watch: {
      page: function(newPage) {
        this.onPageChange(newPage)
      },
    },
    async mounted() {
      this.toggleAppLoader(true)
      const logs = await ApiService.getTimeline(this.$route.params.id)
      if (logs.data) {
        this.paginatedLogs = this.formatTimeline(JSON.parse(JSON.stringify(logs.data.timeline)))
        this.logs = this.paginatedLogs[this.page - 1]
      }
      this.toggleAppLoader(false)
    },
    methods: {
      onPageChange(newPage) {
        this.logs = this.paginatedLogs[newPage - 1]
      },
      formatTimeline(logs) {
        const result = []
        let id = 0
        logs.forEach((item) => {
          const date = item[0]
          const keys = Object.keys(item[1].changes)
          keys.forEach((key, index) => {
            if (['unicia_person_id', 'person_kind',].includes(key)) {
              return result
            } else if (this.$te(`main.enums.fields.${key}`)) {
              const isActionByAdvisor = item[1].from_admin
              if (!item[1].username || !item[1].person_name) {
                return
              }
              result.push({
                id: ++id,
                field: key,
                action: item[1].action,
                label: isActionByAdvisor ? item[1].username : item[1].person_name,
                source: isActionByAdvisor ? 'crm' : 'amundi_immo',
                date,
              })
            }
          })

          return result
        })

        const sortedLogs = sortBy(result, 'date', true)
        const paginatedResults = chunk(sortedLogs, this.perPage)
        this.paginationLength = paginatedResults.length
        this.totalLogs = sortedLogs.length

        return paginatedResults
      },
    },
  }
</script>

<style scoped lang="scss">
.ActivityLog {
  height: 100%;
  .header {
    .title {
      color: $color-001c4b;
      font-size: 1.25em;
      font-weight: 500;
      line-height: 2em;
    }
    .subtitle {
      color: $color-4d4d4f;
      font-size: 1em;
      letter-spacing: 0.24px;
      line-height: 1.5em;
    }
  }
  .header-divider {
    background: rgba(158, 159, 162, 0.32);
    margin-bottom: 47px;
  }
  .content {
    padding-left: 10px;
  }
  .custom-footer {
    width: 100%;
    border-bottom: 1px solid $color-217_223_255;
    text-transform: uppercase;
    font-size: 0.7em;
    .footer-length {
      color: $color-1976d2;
    }
  }
}
</style>
